module.exports = __webpack_public_path__ + "img/4.772f7dbb.jpg";